import loadable from '@loadable/component';

export const HoverOver = loadable(() => import(/* webpackChunkName: 'hover-over' */ './HoverOver'));
